import styles from "./LsBalance.module.scss";
import { inputFocusMessage } from "../../../../Utils/iframeMessenger";
import Text from "../../../Typography/Text/Text";
import arrow from "../../../../Static/images/accordionUp.svg";
import { useState, useRef, useEffect } from "react";
import {
  formatMoneyOnBlur,
  formatMoneyValue,
  formatMoneyDisplay,
  applyMoneyInputValue,
  focusMoneyInputSelection,
  handleMoneyInputKeyDown,
  handleMoneyInputBeforeInput,
} from "../../../../Utils/moneyInput";

const LsBalance = ({
  lsBalanceInfo,
  lsInputChange,
  isManualMode = false,
  displayAmount = "0,00",
  isStale = false,
}) => {
  const [accordionActive, setAccordionActive] = useState(false);
  const input = useRef();

  function calculateBalance() {
    let balance = lsBalanceInfo.services.reduce((accumulator, item) => {
      if (item.amount > 0) {
        return accumulator + item.amount + item.penaltie;
      }
      return accumulator;
    }, 0);
    if (balance > 0) {
      return formatMoneyValue(balance);
    }
    return "0,00";
  }

  function parseAmount(value) {
    return Number(String(value).replace(",", ".")) || 0;
  }

  function onChangeInputValue() {
    const filteredValue = applyMoneyInputValue(input.current);
    if (filteredValue === null) return;

    lsInputChange();
  }

  function onFocusInputValue(e) {
    inputFocusMessage("openNumKeyboard");
    focusMoneyInputSelection(e.target);
  }

  function onBlurInputValue() {
    inputFocusMessage("closeKeyboard");
    input.current.value = formatMoneyOnBlur(input.current.value || "0");
    input.current.dataset.moneyLastValue = input.current.value;
    lsInputChange();
  }

  useEffect(() => {
    if (isManualMode) {
      lsInputChange();
    }
  }, [lsBalanceInfo, isManualMode]);

  return (
    <div
      className={
        accordionActive
          ? `${styles.lsBalance} ${styles.accordionActive}`
          : `${styles.lsBalance}`
      }
    >
      <div className={styles.header}>
        <div className={styles.lsInfo}>
          <div className={styles.ls}>
            <Text size="headerText" fw={500}>
              ЛС № {lsBalanceInfo.number}
            </Text>
          </div>
          <div
            className={styles.service}
            onClick={() => setAccordionActive(!accordionActive)}
          >
            <div className={styles.serviceName}>
              {lsBalanceInfo.service_name}
            </div>
            <div className={styles.arrow}>
              <img src={arrow} alt="" />
            </div>
          </div>
        </div>
        {isManualMode ? (
          <div className={styles.input}>
            <input
              onChange={onChangeInputValue}
              onKeyDown={handleMoneyInputKeyDown}
              onBeforeInput={handleMoneyInputBeforeInput}
              onFocus={onFocusInputValue}
              onBlur={onBlurInputValue}
              defaultValue={displayAmount || calculateBalance()}
              name="lsInput"
              ref={input}
              maxLength={10}
            />
          </div>
        ) : (
          <div
            className={`${styles.amountDisplay} ${isStale ? styles.stale : ""}`}
          >
            {formatMoneyDisplay(parseAmount(displayAmount))}
          </div>
        )}
      </div>
      <div className={styles.content}>
        {lsBalanceInfo.services.map((item, idx) => {
          return (
            <div className={styles.item} key={idx}>
              <div className={styles.serviceTitle}>{item.service_title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LsBalance;
